/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';
import type { GetStudentResponse } from './GetStudentResponse';
import {
    GetStudentResponseFromJSON,
    GetStudentResponseFromJSONTyped,
    GetStudentResponseToJSON,
    GetStudentResponseToJSONTyped,
} from './GetStudentResponse';

/**
 * 
 * @export
 * @interface PaginatedResultOfGetStudentResponse
 */
export interface PaginatedResultOfGetStudentResponse {
    /**
     * 
     * @type {Array<GetStudentResponse>}
     * @memberof PaginatedResultOfGetStudentResponse
     */
    items?: Array<GetStudentResponse>;
    /**
     * 
     * @type {any}
     * @memberof PaginatedResultOfGetStudentResponse
     */
    lastSelectedId?: any | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetStudentResponse
     */
    pageNumber?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetStudentResponse
     */
    pageSize?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof PaginatedResultOfGetStudentResponse
     */
    totalCount?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetStudentResponse
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginatedResultOfGetStudentResponse
     */
    hasPreviousPage?: boolean;
}

/**
 * Check if a given object implements the PaginatedResultOfGetStudentResponse interface.
 */
export function instanceOfPaginatedResultOfGetStudentResponse(value: object): value is PaginatedResultOfGetStudentResponse {
    return true;
}

export function PaginatedResultOfGetStudentResponseFromJSON(json: any): PaginatedResultOfGetStudentResponse {
    return PaginatedResultOfGetStudentResponseFromJSONTyped(json, false);
}

export function PaginatedResultOfGetStudentResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedResultOfGetStudentResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(GetStudentResponseFromJSON)),
        'lastSelectedId': json['lastSelectedId'] == null ? undefined : json['lastSelectedId'],
        'pageNumber': json['pageNumber'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageNumber']),
        'pageSize': json['pageSize'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageSize']),
        'totalCount': json['totalCount'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
    };
}

export function PaginatedResultOfGetStudentResponseToJSON(json: any): PaginatedResultOfGetStudentResponse {
    return PaginatedResultOfGetStudentResponseToJSONTyped(json, false);
}

export function PaginatedResultOfGetStudentResponseToJSONTyped(value?: PaginatedResultOfGetStudentResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(GetStudentResponseToJSON)),
        'lastSelectedId': value['lastSelectedId'],
        'pageNumber': ApiUserTasksGetPageParameterToJSON(value['pageNumber']),
        'pageSize': ApiUserTasksGetPageParameterToJSON(value['pageSize']),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
    };
}

